import { useContext } from "react";
import { useLocation } from "react-router-dom";

import { KBContext } from "../../../Context";
import { useCategoryArticles } from "../../../hooks/apis/useCategoryArticles";
import { useSubCategories } from "../../../hooks/apis/useSubCategories";
import { ArticlesLoader } from "../../Loaders/Articles";
import {
    Card,
    CardWithHeader,
    CardHeader,
    CardHeaderLink,
    CardHeaderText,
    CardTitle,
    CardDescription,
    Divider,
    RowLink,
    RowIcon,
    RowTitle,
    Chevron,
    CategoryRowContent,
    Meta,
    MetaIcon,
} from "./styles";

const CATEGORY_ICON = "folder";

const ArticleRow = ({ title, to }) => (
    <RowLink to={to}>
        <RowIcon className="material-icons-outlined">article</RowIcon>
        <RowTitle>{title}</RowTitle>
        <Chevron className="material-icons-outlined">chevron_right</Chevron>
    </RowLink>
);

const CategoryRow = ({ category, to, brandColor }) => {
    const articleCount = category.immediateArticleCount ?? 0;
    return (
        <RowLink to={to}>
            <RowIcon className="material-icons-outlined" $color={brandColor}>
                {CATEGORY_ICON}
            </RowIcon>
            <CategoryRowContent>
                <RowTitle>{category.title}</RowTitle>
                <Meta>
                    <MetaIcon className="material-icons-outlined">article</MetaIcon>
                    {articleCount} {articleCount === 1 ? "article" : "articles"}
                </Meta>
            </CategoryRowContent>
        </RowLink>
    );
};

export const ArticlesCard = ({ articles, isLoading, loaderCount, getArticlePath }) => {
    if (!isLoading && !articles?.length) {
        return null;
    }
    return (
        <Card>
            {isLoading ? (
                <ArticlesLoader count={loaderCount} />
            ) : (
                articles.map((article) => (
                    <ArticleRow
                        key={article.slug}
                        title={article.title}
                        to={getArticlePath(article)}
                    />
                ))
            )}
        </Card>
    );
};

export const SubCategoryCard = ({ subCategory }) => {
    const { search } = useLocation();
    const { data: { brandColor } } = useContext(KBContext);
    const { data: articles = [], isLoading: isArticlesLoading } = useCategoryArticles({
        categorySlug: subCategory.slug,
    });
    const { data: childCategories = [] } = useSubCategories({
        categorySlug: subCategory.slug,
    });

    return (
        <CardWithHeader>
            <CardHeader>
                <CardHeaderLink to={`/${subCategory.slug}` + search}>
                    <CardHeaderText>
                        <CardTitle>{subCategory.title}</CardTitle>
                        {subCategory.description ? (
                            <CardDescription>{subCategory.description}</CardDescription>
                        ) : null}
                    </CardHeaderText>
                </CardHeaderLink>
                <Divider />
            </CardHeader>
            {isArticlesLoading ? (
                <ArticlesLoader count={subCategory.immediateArticleCount || 2} />
            ) : (
                articles.map((article) => (
                    <ArticleRow
                        key={article.slug}
                        title={article.title}
                        to={`/${subCategory.slug}/${article.slug}` + search}
                    />
                ))
            )}
            {childCategories.map((child) => (
                <CategoryRow
                    key={child.slug}
                    category={child}
                    to={`/${child.slug}` + search}
                    brandColor={brandColor}
                />
            ))}
        </CardWithHeader>
    );
};
